import { Card, ProgressBar, Row, Space } from "@masterteam/mt-design-react";
import React from "react";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import useIsAr from "../../../Hooks/useIsAr";
import { formatDate } from "../../../helpers";

import "./style.scss";

const ProjectCard = ({ data, statuses, isInitiatives = false }) => {
  const [isAr] = useIsAr();
  const intl = useIntl();
  const history = useHistory();

  const status = statuses?.find((e) => e.Code === data?.Status);
  const plannedStatus = statuses?.find((e) => e.Code === data?.PlannedStatus);
  return (
    <Card className="project-card-wrapper">
      <Row className="title">{isAr ? data.ArabicName : data.EnglishName}</Row>

      <Row justify="between" className="items-wrapper">
        <Space direction="vertical" size="medium">
          <Space direction="vertical" size="small" className="item">
            <div className="value">
              {data?.ManagerModel?.DisplayName || "---"}
            </div>
            <div className="label">
              {intl.formatMessage({
                id: "project.manager"
              })}
            </div>
          </Space>

          <Space direction="vertical" size="small" className="item">
            <div className="value">
              {data?.SponsorModel?.DisplayName || "---"}
            </div>
            <div className="label">
              {intl.formatMessage({
                id: "project.sponsor"
              })}
            </div>
          </Space>
        </Space>

        <Space direction="vertical" size="medium">
          <Space direction="vertical" size="small" className="item">
            <div className="value">{formatDate(data?.StartDate)}</div>
            <div className="label">
              {intl.formatMessage({
                id: "project.start-date"
              })}
            </div>
          </Space>

          <Space direction="vertical" size="small" className="item">
            <div className="value">{formatDate(data?.FinishDate)}</div>

            <div className="label">
              {intl.formatMessage({
                id: "project.end-date"
              })}
            </div>
          </Space>
        </Space>
      </Row>

      <Row className="progress" gap="5px">
        <ProgressBar
          value={data?.Progress}
          color={status?.Color}
          headerProgress
          title={intl.formatMessage({
            id: "common.actual-progress"
          })}
        />
        {/* <span style={{ color: data.ColorCode }}>{data.Progress} %</span> */}
      </Row>

      <Row className="progress" gap="5px">
        <ProgressBar
          value={data?.PlannedProgress}
          color={isInitiatives ? "#007DC5" : plannedStatus?.Color}
          headerProgress
          title={intl.formatMessage({
            id: "common.planned-progress"
          })}
        />
        {/* <span style={{ color: data.ColorCode }}>{data.Progress} %</span> */}
      </Row>

      <Row className="details" justify="between">
        <Space direction="vertical" className="item">
          <div className="value">{data?.Budget}</div>
          <div>
            {intl.formatMessage({
              id: "common.budget"
            })}
          </div>
        </Space>

        {!isInitiatives ? null : (
          // <>
          //   <Space direction="vertical" className="item">
          //     <div className="value">{data?.Issues}</div>
          //     <div>
          //       {intl.formatMessage({
          //         id: "common.issues"
          //       })}
          //     </div>
          //   </Space>

          //   <Space direction="vertical" className="item">
          //     <div className="value">{data?.Risks}</div>
          //     <div>
          //       {intl.formatMessage({
          //         id: "common.risks"
          //       })}
          //     </div>
          //   </Space>
          // </>
          <Space direction="vertical" className="item">
            <div className="value">{data?.InitiativeCode}</div>
            <div>
              {intl.formatMessage({
                id: "initiative.code"
              })}
            </div>
          </Space>
        )}
      </Row>
    </Card>
  );
};

export default ProjectCard;
